import scholarships from './scholarships';
import dayima from './dayima';
// 专家义诊相关接口
import freeClinic from './freeClinic';
// 孕育周知相关接口
import knowing from './knowing';
import nim from './nim';
// 专家答专家端相关接口
import expertAnswer from './expertAnswer';
// 小灯塔
import lighthouse from './lighthouse';

export default Object.assign({
  courseRecommend: '/newapi/router/health-recommend/recommend',
  recommendFree: '/newapi/bigHealth/course/recommendFree',  // 获取免费更多推荐，暂时小时光使用
  freeTinyCourseList: '/newapi/bigHealth/bbt/freeTinyCourseList',  // 获取免费小微课，暂时小时光使用
  courseList: '/newapi/bigHealth/expert/courses',
  historyMessage: '/newapi/bigHealth/message/poll',
  pictureList: '/newapi/bigHealth/expert/materiallist',
  deletePicture: '/newapi/bigHealth/expert/deletemateriallist',
  movePicture: '/newapi/bigHealth/expert/movematerial',
  uploadImage: '/newapi/bigHealth/expert/addmaterials',
  wxSign: '/mobile/weixin/ticket.htm',
  expertAuth: '/mobile/weixin/healthLogin.htm',
  queryUserMemberInfo: '/newapi/router/memberInfo/queryUserMemberInfo',
  courseInfo: '/newapi/bigHealth/course/detail',
  newCourseInfo: '/newapi/router/health-courseDetail/detailBaseInfo',  // 新版课程详情页
  courseDetail: '/newapi/router/health-courseDetail/detail',
  courseClose: '/newapi/bigHealth/course2/endCourse',
  addComment: '/newapi/router/health-comment/addCommentGenApi',
  issues: '/newapi/bigHealth/message/questionlist',
  buy: '/newapi/bigHealth/order/buy',             // 下单
  pay: '/newapi/bigHealth/order/pay',              // 去支付
  order: '/newapi/bigHealth/order/getpreorderinfo',              // 订单信息
  jxjOrder: '/newapi/router/healthOrder/getJXJPreOrderInfo',              // 奖学金订单信息
  wxAuth: '/mobile/weixin/authorization.htm',         // 用户授权验证
  wxAuthFx: '/newapi/passport/weixin/getWeixinUserOpenId',  // 配合复兴网红医生特加的微信授权验证
  healthSign: '/mobile/user/getHealthSignByToken.htm', // (获取大健康签名)
  getCatagoryUrl: '/newapi/bigHealth/course/catagory', // 首页分类列表
  indexListUrl: '/newapi/bigHealth/course/list', // 首页列表
  courseLike: '/newapi/bigHealth/course2/like', // 课程点赞
  xwCourseLike: '/newapi/bigHealth/course/tinyCourseLike', // 课程点赞
  messageLike: '/newapi/bigHealth/message/like', // 消息点赞
  UserCourses: '/newapi/bigHealth/my/courses', // 我的开讲
  myCourse: '/newapi/router/health-myCourse/myCourseList', // 我的课程列表
  combinecourses: '/newapi/bigHealth/my/combinecourses', // 我的组合课
  userIssues: '/newapi/bigHealth/message/myquestion',  // 用户问题
  verifycode: '/mobile/user/smsverifycode.htm',  // 发送短信验证码
  bindMobile: '/mobile/weixin/binding.htm',  // 绑定手机
  expertSlides: '/newapi/bigHealth/course2/materials',  // 专家端幻灯片
  postLog: '/newapi/bigHealth/log',  // 日志接口
  hotLabel: '/newapi/bigHealth/course/hotLabeList',   // 日志接口
  treeCoin: '/newapi/bigHealth/my/shubi',  // 树币个人中心
  treeCoinList: '/newapi/bigHealth/my/shubilist',  // 树币明细
  queryBalance: '/newapi/router/shubi/queryShubiBalance', // 树币余额查询接口(openapi) http://space.babytree-inc.com/pages/viewpage.action?pageId=18310448
  queryBalanceDetail: '/newapi/router/shubi/queryShubiSchedule',
  tags: '/newapi/bigHealth/course/labelpage', // 标签页
  tagsSubject: '/newapi/bigHealth/course/labelsubject', // 标签聚合页
  myTinyCourses: '/newapi/bigHealth/my/tinycourses', // 我的微课 HEAD
  serialList: '/newapi/router/health-courseList/serialList', // 系列课列表
  serialdetail: '/newapi/bigHealth/course/serialdetail', // 系列课详情页
  combineList: '/newapi/router/health-courseList/combineList', // 组合课程列表
  querybycode: '/newapi/bigHealth/order/querybycode', // 根据订单号获取订单详情
  getStatus: '/mobile/account/querypayidres.htm', // 支付页面-获取支付状态
  freeList: '/newapi/router/health-expertFree/freeList', // 新版-免费专区
  courseRemind: '/newapi/router/health-homePageV2/courseRemind', // 新版-首页课程收听提示条
  homePage: '/newapi/router/health-homePageV2/homePageV2', // 新版-首页数据
  recommend: '/newapi/router/health-homePageV2/recommendForUser', // 新版-为你推荐
  indexModuleList: '/newapi/router/health-module/getModuleList', // 新版首页接口 首页模块列表 2018-6-21
  auditionList: '/newapi/router/health-serialCourse/subCourseList', // 试听列表
  columndetail: '/newapi/router/health-courseForApp/serialDetailGenApi', // 订阅课父课详情页
  subCourseList: '/newapi/router/health-serialCourse/subCourseList', // 订阅课子课程列表
  childDetail: '/newapi/router/health-courseForApp/subscriptionLeafCourseDetail', // 订阅课子课程详情
  columnList: '/newapi/router/health-courseForApp/tinyCourseListGenApi', // 订阅课父课程列表
  setLeaveMessage: '/newapi/router/health-userguestbook/insert', // 留言入库
  myGuestBooks: '/newapi/router/health-userguestbook/myGuestBooks', // 我的留言
  delGuest: '/newapi/router/health-userguestbook/delete', // 删除留言
  messageList: '/newapi/router/health-guestbook/list', // 留言列表
  giveThumbsup: '/newapi/bigHealth/fitness/giveTheThumbsup',  // 点赞/取消点赞（训练动态/用户/精品课留言/回复）
  courseExperts: '/newapi/router/health-courseExperts/courseExperts',  // 详情页专家列表
  expertsLabel: '/newapi/router/health-courseExperts/courseExperts',  // 详情页专家标签列表
  classifyLabel: '/newapi/router/health-courseLabel/courseLabelList',  // 详情页分类标签列表
  myIncome: '/newapi/router/health-distribution/myDistributionProfit',  // 我的收益
  courseShareImage: '/newapi/router/health-courseShare/courseShareImage',  // 分销 - 分享图片生成接口
  expertCourseList: '/newapi/router/health-expertCourse/expertCourseList',  // 专家端--专家课程列表
  delMsgReply: '/newapi/router/health-gbreply/delete', // 专家端删除回复
  replyMsg: '/newapi/router/health-gbreply/reply', // 专家端回复留言
  constantData: '/newapi/router/memberData/getConstantData',  // 获取后台配置的静态数据
  memberFreeCourse: '/newapi/router/health-memberCourse/freeCourseForMember', // 会员免费听
  queryCertificateType: '/newapi/router/passport/config/queryCertificateType', // 查询实名认证模式
  commentTags: '/newapi/router/health-comment/getCourseCommentTags',  // 获取课程评价列表页标签列表
  getCourseComments: '/newapi/router/health-comment/getCourseComments', // 分页获取课程评价及点评列表
  getCourseAudioUrl: '/newapi/router/health-audios/getCourseAudioUrl', // 获取课程的音频链接
  channelModule: '/newapi/router/health-channel/getChannelModuleList', // 频道页模块接口
  channelRecommend: '/newapi/router/health-channel/getChannelRecommendList',  // 频道页推荐课程接口
  getCategoryList: '/newapi/router/health-channel/getFrontCategoryList',  // 频道页查询分类列表接口
  adByCodes: '/newapi/router/cms/advertise/findAdvertiseByCodes',    // cms配置广告位
  courseRankList: '/newapi/router/courseRank/getCourseRankList',          // 课程排行榜
  wyethCourse: '/newapi/router/course/vip/getCourseListForVip',          // 惠氏 w+会员权益免费听课程列表
  wyethLogin: '/newapi/router/ua/account/login',          // 惠氏 w+会员自动登录
  getAuthToken: '/openapi/getTokenByLoginString'
}, scholarships, dayima, freeClinic, knowing, nim, expertAnswer, lighthouse);



// WEBPACK FOOTER //
// ./src/comm/api/apis.js